import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Fade as Hamburger } from "hamburger-react";
import { UserCounts } from "../../services/SignUpReport/SignUpReport";
import { getAdminProfile, logoutService } from "../../services/authService";
import {
  FaGraduationCap,
  FaFileAlt,
  FaRoute,
  FaUserCircle,
  FaChartBar,
  FaCogs,
  FaHandshake,
  FaNewspaper,
  FaBoxes,
  FaBullhorn,
  FaUserPlus,
  FaMoneyCheckAlt,
  FaFileInvoice,
  FaTruck,
  FaUsers,
  FaMobileAlt,
  FaBell,
  FaTachometerAlt,
  FaUserCog,
} from "react-icons/fa";
import { MdImage } from "react-icons/md";
import {
  LayoutDashboard,
  Zap,
  Layers,
  FileCheck,
  PlusSquare,
  CheckCircle,
  Landmark,
  FileText,
  ShieldCheck,
  UserCheck,
  Users,
  CreditCard,
  UserPlus,
  Database,
  BarChart3,
  TrendingUp,
  Truck,
  List,
  Smartphone,
  UserCog,
  Settings,
  Newspaper,
  Image,
  Package,
  GraduationCap,
  Route,
  User,
  ClipboardList,
  Wallet,
  Receipt,
  Percent,
  KeyRound,
  Mail,
  FileStack,
  Lock,
  CheckSquare,
  FileSpreadsheet,
  Menu,
  SidebarClose,
  SidebarIcon,
  SidebarOpen,
  X,
  UserCog2,
  Bell,
  ReceiptIndianRupee,
  Settings2,
  Handshake,
  PackageOpen,
  ShieldCheckIcon,
  UserPlus2,
  UserRoundCheckIcon,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

import { FetchEmployeePermissions } from "../../services/apiService";
import ViewAdminProfile from "../Components/ViewsModals/AdminProfile";

const SideBarMenuDashboard = ({ setUser, setSidebarStatus }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState(null);
  const navigate = useNavigate();
  const [userProfile, setUserProfile] = useState(null);

  const [pendingCount, setPendingCount] = useState(0);
  const [allAdminRoutes, setAllAdminRoutes] = useState();
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const [profileClicked, setProfileClicked] = useState(false);

  useEffect(() => {
    const getPendingCount = async () => {
      try {
        const result = await UserCounts({ status: "PENDING" });

        const count = result?.data?.count ?? result?.count ?? 0;

        if (!count) {
          // 🔴 No data found → Logout
          await logoutService();

          // Clear local storage if needed
          localStorage.clear();

          // Redirect immediately to login
          navigate("/", { replace: true });
          return;
        }

        setPendingCount(count);
      } catch (error) {
        // 🔴 API error → Logout for safety
        console.error("UserCounts failed:", error);

        await logoutService();
        localStorage.clear();
        navigate("/", { replace: true });
      }
    };

    getPendingCount();
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
    setSidebarStatus(!isSidebarOpen);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleMenuClick = (menuId) => {
    setActiveMenu(activeMenu === menuId ? null : menuId);
  };

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getAdminProfile();
        if (res?.data?.user_id) {
          setUserProfile(res?.data);
          setUser(res?.data);
        }
      } catch (error) {
        console.error("Error fetching mobile number", error);
      }
    };
    fetchProfile();
  }, []);

  const fetchPermissions = async () => {
    try {
      const res = await FetchEmployeePermissions({
        user_id: userProfile?.user_id,
      });

      if (res) {
        const routes = res?.data?.routes || [];

        setAllAdminRoutes(routes);

        setSelectedPermissions(
          routes.filter((item) => item.assigned).map((item) => item.route_path),
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (!userProfile?.user_id) return;
    fetchPermissions();
  }, [userProfile?.user_id]);

  return (
    <>
      {/* Toggle Button for Mobile */}
      <button
        onClick={toggleSidebar}
        className="fixed left-1 z-50 size-11 bg-blue-600 text-white rounded-full md:hidden"
      >
        {isSidebarOpen ? (
          <Hamburger duration={1} size={20} />
        ) : (
          <Hamburger duration={1} size={20} />
        )}
      </button>

      {/* Main Container */}
      <div
        className={`main-container  h-full  inset-0 z-30 ${isSidebarOpen ? "" : "sidebar-closed"}`}
        id="container"
      >
        {/* Overlay for closing sidebar */}
        {/* <div
          className={`overlay md:hidden inset-0 bg-black opacity-50  ${isSidebarOpen ? "block" : "hidden"}`}
          onClick={toggleSidebar}
        ></div> */}

        {/* Sidebar */}
        <aside
          className={`fixed top-16 left-0 h-screen z-40 transition-all duration-300
  ${isSidebarOpen ? " sidebar-open" : "w-[110px] sidebar-closed"}
  bg-slate-900`}
        >
          {/* Sidebar Content */}
          <motion.div animate={{ x: [0, 100, 0] }}>
            {/* {!SidebarOpen && ( */}
            <button
              onClick={toggleSidebar}
              className="fixed size-11 -z-10 top-[90px] left-5  md:items-center md:justify-center  bg-white text-blue-900 rounded-full hidden md:flex"
            >
              {/* {isSidebarOpen ? (
                <Hamburger duration={1} size={24} />
              ) : (
                <Hamburger duration={1} size={24} />
              )} */}

              <ChevronsRight />
            </button>
            {/* )} */}
            <nav className="px-6 z-10 min-h-[100%] bg-[#0A1F44] py-1">
              <div
                className="flex items-center justify-between rounded-lg px-4 py-6 
border-b border-white/10 "
              >
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-slate-100 to-slate-400 font-bold text-xl tracking-tight">
                  IDSpay<span className="text-cyan-400">Admin</span>
                </span>

                <button
                  onClick={toggleSidebar}
                  className="flex items-center justify-center 
    h-8 w-8 rounded-full bg-white/10 
     
    text-blue-100 hover:text-white
    transition-all duration-200"
                >
                  <ChevronsLeft size={24} />
                </button>
              </div>

              <ul
                className="list-none menu-categories space-y-2.5 mt-2 overflow-y-auto pb-10 max-h-[80%]"
                style={{ scrollbarWidth: "none" }}
              >
                {!selectedPermissions.includes("admin-dashboard") && (
                  <li className="menu">
                    <Link
                      to="/"
                      id="dashboard"
                      className="flex  items-center py-2 rounded-lg  px-3  text-white hover:bg-cyan-500  border-l-4 border-l-blue-200 transition duration-300
            ease-in-out delay-50 bg-blue-600   
             "
                      onClick={() => handleMenuClick("dashboard")}
                    >
                      <LayoutDashboard className=" mr-2 size-5" />
                      <span className="">Dashboard</span>
                    </Link>
                  </li>
                )}

                {(!selectedPermissions.includes("ApiAccount") ||
                  !selectedPermissions.includes("ApiUserKyc") ||
                  !selectedPermissions.includes("ApiApproveKyc") ||
                  !selectedPermissions.includes("Wallet_balance_management") ||
                  !selectedPermissions.includes("BillingMaster") ||
                  !selectedPermissions.includes("wallet-transaction-report") ||
                  !selectedPermissions.includes("CommissionMaster") ||
                  !selectedPermissions.includes("ManagePermission") ||
                  !selectedPermissions.includes("GenerateQuotation") ||
                  !selectedPermissions.includes("FundApprove")) && (
                  <li
                    className={`menu ${activeMenu === "apiUser" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3 text-white bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200
               "
                      onClick={() => handleMenuClick("apiUser")}
                    >
                      <UserCog2 className=" mr-2 size-5" />
                      <span>API User</span>
                    </button>
                    {activeMenu === "apiUser" && (
                      <ul className="mx-4 mt-2 py-2 rounded-lg space-y-2">
                        {!selectedPermissions.includes("ApiAccount") && (
                          <li>
                            <Link
                              to="/ApiAccount"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Create API Account
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("ApiUserKyc") && (
                          <li>
                            <Link
                              to="/ApiUserKyc"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Upload KYC
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("ApiApproveKyc") && (
                          <li>
                            <Link
                              to="/ApiApproveKyc"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Approve Kyc
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes(
                          "Wallet_balance_management",
                        ) && (
                          <li>
                            <Link
                              to="/Wallet_balance_management"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Wallet Bal Management
                            </Link>
                          </li>
                        )}
                        {!selectedPermissions.includes("BillingMaster") && (
                          <li>
                            <Link
                              to="/BillingMaster"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Billing Master
                            </Link>
                          </li>
                        )}
                        {!selectedPermissions.includes("GenerateQuotation") && (
                          <li>
                            <Link
                              to="/GenerateQuotation"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Generate Quotation
                            </Link>
                          </li>
                        )}
                        {!selectedPermissions.includes(
                          "wallet-transaction-report",
                        ) && (
                          <li>
                            <Link
                              to="/wallet-transaction-report"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Wallet History
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("CommissionMaster") && (
                          <li>
                            <Link
                              to="/CommissionMaster"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Commission Master
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("ManagePermission") && (
                          <li className="mb-3">
                            <Link
                              to="/ManagePermission"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Manage Permission
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("FundApprove") && (
                          <li className="mb-3">
                            <Link
                              to="/FundApprove"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Fund Approve
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {(!selectedPermissions.includes("PartnerReport") ||
                  !selectedPermissions.includes("CreatePartner")) && (
                  <li
                    className={`menu ${activeMenu === "Partner" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    bg-blue-600  hover:bg-cyan-500  border-l-4 border-l-blue-200    "
                      onClick={() => handleMenuClick("Partner")}
                    >
                      <Handshake className=" mr-2 size-5" />
                      <span>Partner</span>
                    </button>
                    {activeMenu === "Partner" && (
                      <ul className="mx-4 pb-2 mt-2 space-y-2">
                        {!selectedPermissions.includes("CreatePartner") && (
                          <li>
                            <Link
                              to="/CreatePartner"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Create Partner
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("PartnerReport") && (
                          <li>
                            <Link
                              to="/PartnerReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Partner Report
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {!selectedPermissions.includes("GenerateMerchantToken") && (
                  <li
                    className={`menu ${activeMenu === "MerchantToken" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200    "
                      onClick={() => handleMenuClick("MerchantToken")}
                    >
                      <KeyRound className=" mr-2 size-5" />
                      <Link to="/GenerateMerchantToken" className="">
                        Merchant Token
                      </Link>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("SignUpReport") && (
                  <li
                    className={`menu ${
                      activeMenu === "SignUpReport"
                        ? "bg-blue-600 text-red-600 rounded-lg"
                        : ""
                    }`}
                  >
                    <button
                      className="flex items-center justify-between w-full py-2 rounded-lg  px-3 bg-blue-600  text-white ease-in-out delay-50 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("SignUpReport")}
                    >
                      <div className="flex items-center">
                        <UserPlus className=" mr-2 size-5" />
                        <Link to="/SignUpReport" className="text-sm">
                          SignUp Report
                        </Link>
                      </div>

                      {/* 🔔 Show Pending Count */}
                      <div className="relative">
                        <Bell className=" mr-2 size-5 animate-pulse" />
                        {pendingCount > 0 && (
                          <span className="absolute  -top-1 -right-1 flex p-1 items-center justify-center bg-amber-400 text-black text-[8px] font-bold rounded-full shadow-md animate-bounce">
                            {pendingCount || ""}
                          </span>
                        )}
                      </div>
                    </button>
                  </li>
                )}
                {/* {!selectedPermissions.includes("PartnerReport") && (
                  <li
                    className={`menu ${
                      activeMenu === "PartnerReport"
                        ? "bg-blue-600 text-red-600 rounded-lg"
                        : ""
                    }`}
                  >
                    <button
                      className="flex items-center justify-between w-full py-2 rounded-lg  px-3 bg-blue-600  text-white ease-in-out delay-50 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("PartnerReport")}
                    >
                      <div className="flex items-center">
                        <UserRoundCheckIcon className=" mr-2 size-5" />
                        <Link to="/PartnerReport" className="text-sm">
                          Partner Report
                        </Link>
                      </div>
                    </button>
                  </li>
                )} */}
                {/* {!selectedPermissions.includes("CreatePartner") && (
                  <li
                    className={`menu ${
                      activeMenu === "CreatePartner"
                        ? "bg-blue-600 text-red-600 rounded-lg"
                        : ""
                    }`}
                  >
                    <button
                      className="flex items-center justify-between w-full py-2 rounded-lg  px-3 bg-blue-600  text-white ease-in-out delay-50 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("CreatePartner")}
                    >
                      <div className="flex items-center">
                        <UserRoundCheckIcon className=" mr-2 size-5" />
                        <Link to="/CreatePartner" className="text-sm">
                          Create Partner
                        </Link>
                      </div>
                    </button>
                  </li>
                )} */}

                {(!selectedPermissions.includes("IdfcVanConfig") ||
                  !selectedPermissions.includes("IdfcVanReport") ||
                  !selectedPermissions.includes("ProvidersReport")) && (
                  <li
                    className={`menu ${activeMenu === "manageCollections" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full rounded-lg text-white  px-2 py-2  hover:bg-cyan-500  border-l-4 border-l-blue-200
     bg-blue-600  "
                      onClick={() => handleMenuClick("manageCollections")}
                    >
                      <ReceiptIndianRupee className=" mr-2 size-5" />
                      <span>Manage Collections</span>
                    </button>
                    {activeMenu === "manageCollections" && (
                      <ul className="mx-4 py-2 mt-2 space-y-2">
                        {!selectedPermissions.includes("IdfcVanConfig") && (
                          <li>
                            <Link
                              to="/IdfcVanConfig"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Idfc Van Config.
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("IdfcVanReport") && (
                          <li>
                            <Link
                              to="/IdfcVanReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Idfc Van Report
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("ProvidersReport") && (
                          <li>
                            <Link
                              to="/ProvidersReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Providers Report
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {(!selectedPermissions.includes("SendEmail") ||
                  !selectedPermissions.includes("EmailConfig") ||
                  !selectedPermissions.includes("TemplateMaster")) && (
                  <li
                    className={`menu ${activeMenu === "bulkEmail" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full rounded-lg  px-2 py-2 text-white hover:bg-cyan-500  border-l-4 border-l-blue-200
     bg-blue-600  "
                      onClick={() => handleMenuClick("bulkEmail")}
                    >
                      <Mail className=" mr-2 size-5" />
                      <span>Bulk Email</span>
                    </button>
                    {activeMenu === "bulkEmail" && (
                      <ul className="mx-4 mt-2 space-y-2">
                        {!selectedPermissions.includes("SendEmail") && (
                          <li>
                            <Link
                              to="/SendEmail"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Send Email
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("EmailConfig") && (
                          <li>
                            <Link
                              to="/EmailConfig"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Email Config
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("TemplateMaster") && (
                          <li>
                            <Link
                              to="/TemplateMaster"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Template
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {!selectedPermissions.includes("IfscMaster") && (
                  <li
                    className={`menu ${activeMenu === "IfscMaster" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-4  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("IfscMaster")}
                    >
                      <Landmark className=" mr-2 size-5" />
                      <Link to="/IfscMaster" className="">
                        Ifsc Master
                      </Link>
                      <span className="text-amber-400 animate-scrollUp text-xs font-bold mt-1 ms-1">
                        New
                      </span>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("DocumentMaster") && (
                  <li
                    className={`menu ${activeMenu === "DocumentMaster" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-4  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("DocumentMaster")}
                    >
                      <FileText className=" mr-2 size-5" />
                      <Link to="/DocumentMaster" className="">
                        Document Master
                      </Link>
                      <span className="text-amber-400 animate-scrollUp text-xs font-bold mt-1 ms-1">
                        New
                      </span>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("ConsentMaster") && (
                  <li
                    className={`menu ${activeMenu === "ConcentMaster" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-4  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("ConcentMaster")}
                    >
                      <ShieldCheck className=" mr-2 size-5" />
                      <Link to="/ConsentMaster" className="">
                        Consent Master
                      </Link>
                      <span className="text-amber-400 animate-scrollUp text-xs font-bold mt-1 ms-1">
                        New
                      </span>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("VendorMaster") && (
                  <li
                    className={`menu ${activeMenu === "VendorMaster" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-4  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("VendorMaster")}
                    >
                      <Truck className=" mr-2 size-5" />
                      <Link to="/VendorMaster" className="">
                        Vendor Master
                      </Link>
                      <span className="text-amber-400 animate-scrollUp text-xs font-bold mt-1 ms-1">
                        New
                      </span>
                    </button>
                  </li>
                )}

                {(!selectedPermissions.includes("RegEmployee") ||
                  !selectedPermissions.includes("RegEmployeeReport") ||
                  !selectedPermissions.includes("CheckPermissions")) && (
                  <li
                    className={`menu ${activeMenu === "Regemployee" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full rounded-lg  px-2 py-2 text-white hover:bg-cyan-500  border-l-4 border-l-blue-200
     bg-blue-600  "
                      onClick={() => handleMenuClick("Regemployee")}
                    >
                      <Users className=" mr-2 size-5" />
                      <span>Employee Master</span>
                    </button>
                    {activeMenu === "Regemployee" && (
                      <ul className="mx-4 mt-2 space-y-2 py-2">
                        {!selectedPermissions.includes("RegEmployee") && (
                          <li>
                            <Link
                              to="/RegEmployee"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Register Employee
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("RegEmployeeReport") && (
                          <li>
                            <Link
                              to="/RegEmployeeReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Employee Report
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("CheckPermissions") && (
                          <li>
                            <Link
                              to="/CheckPermissions"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Check Employee Permission
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {!selectedPermissions.includes("MobileDeviceLockReport") && (
                  <li
                    className={`menu ${activeMenu === "MobileDeviceLock" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-2  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("MobileDeviceLock")}
                    >
                      <Smartphone className=" mr-1 size-5" />
                      <Link to="/MobileDeviceLockReport" className="">
                        Mobile Device Lock
                      </Link>
                      <span className="text-amber-400 animate-scrollUp text-xs font-bold mt-1 ms-1">
                        New
                      </span>
                    </button>
                  </li>
                )}

                {(!selectedPermissions.includes("AssignedReport") ||
                  !selectedPermissions.includes("PayoutReport") ||
                  !selectedPermissions.includes("CustomerReport") ||
                  !selectedPermissions.includes("ApiServiceReport") ||
                  !selectedPermissions.includes("ServiceList") ||
                  !selectedPermissions.includes("ServiceUsageReport") ||
                  !selectedPermissions.includes("RevenueReport") ||
                  !selectedPermissions.includes("MandateReport") ||
                  !selectedPermissions.includes("BulkReport") ||
                  !selectedPermissions.includes("ApiKeyReport")) && (
                  <li
                    className={`menu ${activeMenu === "reports" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-4 text-white
     bg-blue-600  hover:bg-cyan-500  border-l-4 border-l-blue-200    "
                      onClick={() => handleMenuClick("reports")}
                    >
                      <BarChart3 className=" mr-2 size-5" />
                      <span>Reports</span>
                    </button>
                    {activeMenu === "reports" && (
                      <ul className="mx-4 py-2 mt-2 space-y-2">
                        {!selectedPermissions.includes("AssignedReport") && (
                          <li>
                            <Link
                              to="/AssignedReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Assigned Report
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("PayoutReport") && (
                          <li>
                            <Link
                              to="/PayoutReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Payout Report
                            </Link>
                          </li>
                        )}
                        {!selectedPermissions.includes("MandateReport") && (
                          <li>
                            <Link
                              to="/MandateReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Mandate Report
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("BulkReport") && (
                          <li>
                            <Link
                              to="/BulkReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Bulk Service Report
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("CustomerReport") && (
                          <li>
                            <Link
                              to="/CustomerReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Customer Report
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("ApiServiceReport") && (
                          <li>
                            <Link
                              to="/ApiServiceReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              API Service Report
                              <span className="text-red-600 animate-scrollUp text-xs mt-1">
                                New
                              </span>
                            </Link>
                          </li>
                        )}
                        {!selectedPermissions.includes("ServiceList") && (
                          <li>
                            <Link
                              to="/ServiceList"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              API Service List
                              <span className="text-red-600 animate-scrollUp text-xs mt-1">
                                New
                              </span>
                            </Link>
                          </li>
                        )}
                        {!selectedPermissions.includes("ServiceUsageReport") && (
                          <li>
                            <Link
                              to="/ServiceUsageReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Service Usage Report
                              <span className="text-red-600 animate-scrollUp text-xs mt-1">
                                New
                              </span>
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("RevenueReport") && (
                          <li>
                            <Link
                              to="/RevenueReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Service Revenue Report
                              <span className="text-red-600 animate-scrollUp text-xs mt-1">
                                New
                              </span>
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("ApiKeyReport") && (
                          <li>
                            <Link
                              to="/ApiKeyReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              APIKey Report
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {(!selectedPermissions.includes("AddService") ||
                  !selectedPermissions.includes("ActiveServiceReport") ||
                  !selectedPermissions.includes("ActivateService") ||
                  !selectedPermissions.includes("ActivateServiceBulk")) && (
                  <li
                    className={`menu ${activeMenu === "services" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
     ease-in-out delay-50 bg-blue-600  hover:bg-cyan-500  border-l-4 border-l-blue-200 "
                      onClick={() => handleMenuClick("services")}
                    >
                      <Settings2 className=" mr-2 size-5" />
                      <span>Services</span>
                    </button>
                    {activeMenu === "services" && (
                      <ul className="mx-4 mt-2 py-2 space-y-2">
                        {!selectedPermissions.includes("AddService") && (
                          <li>
                            <Link
                              to="/AddService"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Add Service
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes(
                          "ActiveServiceReport",
                        ) && (
                          <li>
                            <Link
                              to="/ActiveServiceReport"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Active Service Report
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes("ActivateService") && (
                          <li>
                            <Link
                              to="/ActivateService"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Activate Service
                            </Link>
                          </li>
                        )}

                        {!selectedPermissions.includes(
                          "ActivateServiceBulk",
                        ) && (
                          <li>
                            <Link
                              to="/ActivateServiceBulk"
                              className="block p-1   bg-blue-100 rounded-lg hover:bg-blue-200 transition duration-300 text-black ease-in-out delay-10 hover:-translate-y-1 hover:scale-40"
                            >
                              Activate Service Bulk
                              <span className="text-red-600 animate-scrollUp text-xs font-bold mt-1 ms-4">
                                New
                              </span>
                            </Link>
                          </li>
                        )}
                      </ul>
                    )}
                  </li>
                )}

                {!selectedPermissions.includes("News") && (
                  <li
                    className={`menu ${activeMenu === "MasterNews" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200    "
                      onClick={() => handleMenuClick("MasterNews")}
                    >
                      <Newspaper className=" mr-2 size-5" />
                      <Link to="/News" className="">
                        Master News
                      </Link>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("ProductList") && (
                  <li
                    className={`menu ${activeMenu === "ProductList" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("ProductList")}
                    >
                      <Package className=" mr-2 size-5" />
                      <Link to="/ProductList" className="">
                        Product List
                      </Link>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("ProductNews") && (
                  <li
                    className={`menu ${activeMenu === "ProductNews" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("ProductNews")}
                    >
                      <PackageOpen className=" mr-2 size-5" />
                      <Link to="/ProductNews" className="">
                        Product News
                      </Link>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("Banner") && (
                  <li
                    className={`menu ${activeMenu === "Banner" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("Banner")}
                    >
                      <Image className=" mr-2 size-5" />
                      <Link to="/Banner" className="">
                        Login Banner
                      </Link>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("MasterTraining") && (
                  <li
                    className={`menu ${activeMenu === "MasterTraining" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("MasterTraining")}
                    >
                      <GraduationCap className=" mr-2 size-5" />
                      <Link to="/MasterTraining" className="text-sm">
                        Master Training
                      </Link>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("MasterPage") && (
                  <li
                    className={`menu ${activeMenu === "MasterPage" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("MasterPage")}
                    >
                      <Settings className=" mr-2 size-5" />
                      <Link to="/MasterPage" className="text-sm">
                        Master Page
                      </Link>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("RouteList") && (
                  <li
                    className={`menu ${activeMenu === "Routes" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("Routes")}
                    >
                      <Route className=" mr-2 size-5" />
                      <Link to="/RouteList" className="text-sm">
                        List Routes
                      </Link>
                    </button>
                  </li>
                )}

                {!selectedPermissions.includes("Profile") && (
                  <li
                    className={`menu ${activeMenu === "Profile" ? "bg-blue-600 text-red-600 rounded-lg" : ""}`}
                  >
                    <button
                      className="flex items-center w-full py-2 rounded-lg  px-3  text-white
    ease-in-out delay-50 bg-blue-600 hover:bg-cyan-500  border-l-4 border-l-blue-200  "
                      onClick={() => handleMenuClick("Profile")}
                    >
                      <User className=" mr-2 size-5" />
                      <Link to="/Profile" className="text-sm">
                        Profile
                      </Link>
                    </button>
                  </li>
                )}
              </ul>
            </nav>
          </motion.div>
        </aside>
        {/* 
        <ViewAdminProfile
          isOpen={profileClicked}
          onClose={() => setProfileClicked(!profileClicked)}
          profileData={userProfile}
        /> */}
      </div>
    </>
  );
};

export default SideBarMenuDashboard;
